// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"6f2db8d4","453":"37ea012f","565":"07cd0203","865":"8c6e1d01"}[chunkId] + ".chunk.js";
};